import { actions as sessionActions } from '@clearscore/redux.session';
import { resetUser } from '@clearscore/helpers.segment';
import { removeSessionCookie } from '@clearscore/helpers.cookies';

const TIMEOUT_STATUS_CODES = [401, 403];

/**
 * Check if the action is an error and a timeout status code
 * @param {object} action redux action
 * @returns {boolean} if action structure is correct
 */
function _isTimeout(action) {
    const { payload = {} } = action;
    return (
        action &&
        action.type &&
        !action.type.includes('LOGIN') &&
        action.type.includes('ERROR') &&
        TIMEOUT_STATUS_CODES.includes(payload.status)
    );
}

/**
 * Handle the removing of the session cookie
 * @param {function} store of app
 * @param {function} next next middleware func
 * @param {object} action redux action
 * @returns {void}
 */
function _handleTimeout(store, next, action) {
    removeSessionCookie();
    resetUser();
    next(action); // remove session + cookies before doing anything else
    store.dispatch(sessionActions.timeout());
}

/**
 * If action has correct signature, perform cookie storage
 * @returns {Function} middleware
 */
const timeoutMiddleware = () => (store) => (next) => (action) =>
    _isTimeout(action) ? _handleTimeout(store, next, action) : next(action);

export default timeoutMiddleware;
